<template>
  <div>
    <div id="donut-chart" style="width: 100%; height: 400px;"></div>
  </div>
</template>

<script>
import Highcharts from "highcharts";
export default {
  name: "StatSoucrePie",
  props: [],
  components: {},
  data() {
    return {
      chartData:{'text_evidence': 81047, 'figure_evidence': 7655, 'experiment': 1699742, 'cohort': 213412}
    }
  },
  methods: {
    renderChart() {
      // Prepare the data for Highcharts
      const seriesData = Object.entries(this.chartData).map(([key, value]) => {
        return { name: key.replace("_", " ").toUpperCase(), y: value, count: value };
      });

      // Render the Highcharts chart
      Highcharts.chart("donut-chart", {
        chart: {
          type: "pie",
        },
        title: {
          text: "Evidence Distribution",
        },
        tooltip: {
          pointFormat: `
<!--            <b>{point.name}</b><br>-->
            <b>Percentage: {point.percentage:.1f}%</b><br>
            <b>Evidence Count: {point.count}</b>
          `,
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            dataLabels: {
              enabled: true,
              format: "<b>{point.name}</b>: {point.percentage:.1f} %",
            },
            innerSize: "50%", // Creates the donut effect
          },
        },
        series: [
          {
            name: "Evidence",
            colorByPoint: true,
            data: seriesData,
          },
        ],
        exporting:{
            enabled:false
        }
      });
    },
  },
  mounted() {
    this.renderChart();

  }
}
</script>

<style type="text/scss" lang="scss" scoped>

</style>